// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideUser2 as RawLucideUser2 } from "lucide-react";
export const LucideUser2 = /* @__PURE__ */ createIcon(RawLucideUser2, "LucideUser2", 2);
